<template>
  <card-modal-component
    :show="show_modal"
    @deactivate="toggleModal()"
    transition="fade"
    ref="rejectCaseModal"
    :options="{ hasOkBtn: { text: 'Save' }, hasCancelBtn: { enabled: true }}"
    @handleOk="submitComment($event)"
    @handleCancel="toggleModal()"
    :title="`Reject case`">
    <template slot="ok-text" v-translate>Cancel case</template>
    <form-component
      slot="card-content"
      v-for="formDescriptor in formDescriptors"
      :formDescriptor="formDescriptor"
      :formData="getFormDataForDescriptor(formDescriptor)"
      :key="formDescriptor.id">
    </form-component>
  </card-modal-component>
</template>
<script>

  import { mapState, mapActions } from 'vuex'
  import FormComponent from '@/components/form/FormComponent'
  import CardModalComponent from '@/components/layout/modal/CardModalComponent'
  import { formHandlerMixin } from '@/mixins/mixins'
  import { globalEventBus } from '@/utility/utility_functions'

  export default {
    name: 'reject-case-modal-component',
    mixins: [formHandlerMixin],
    components: {
      FormComponent,
      CardModalComponent
    },
    data () {
      return {
        show_modal: false
      }
    },
    props: {
      caseId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.caseModule.closeCaseFormDescriptor,
        formDatas: state => state.caseModule.closeCaseFormData,
        cases: state => state.caseModule.cases
      })
    },
    methods: {
      ...mapActions([
        'setCase',
        'setupRejectCloseCaseForm',
        'saveCloseCaseForm'
      ]),
      toggleModal (btn) {
        btn && btn.enable()
        this.show_modal = !this.show_modal
      },
      submitComment (btn) {
        let requestData = {
          caseId: this.caseId,
          formDatas: this.formDatas
        }
        this.submitRequest = this.saveCloseCaseForm
        this.submitForm(requestData, btn, this.submitCommentCallback)
      },
      submitCommentCallback () {
        this.show_modal = false
        this.$refs.rejectCaseModal.closeModal().then(() => {
          this.setCase(this.caseId).then(() => {
            this.$router.push({ name: 'CaseView', params: { caseId: this.caseId } })
            this.$emit('onReject')
          }).catch((err) => {
            this.handleError(err)
          })
        })
      }
    },
    created () {
      globalEventBus.$on('reject-case-toggle-modal', this.toggleModal)
      this.setupRejectCloseCaseForm(this.caseId).catch((err) => {
        this.handleError(err)
      })
    }
  }
</script>
